import parseNumber from "@store/Framework/Common/Utilities/parseNumber";
import Color from "color";

const STATIC_PATH = "/userfiles/_static/store";

// -- Typography

const fallbackFont = "Arial, Helvetica, sans-serif";

export const TYPOGRAPHY = {
    fontFamily: {
        title: `'aktiv-grotesk', ${fallbackFont}`,
        base: `'aktiv-grotesk', ${fallbackFont}`,
    },
    weight: {
        base: 400,
        medium: 500,
        bold: 700,
        black: 800,
    },
    size: {
        veryTiny: "10px",
        tiny: "12px",
        smallest: "13px",
        smaller: "14px",
        small: "15px",
        base: "16px",
        large: "18px",
        larger: "20px",
    },
    lineHeight: {
        smaller: 1,
        small: 1.25,
        base: 1.5,
        large: 2,
    },
    spacing: {
        small: "0.5em",
        base: "1em",
        large: "1.5em",
        larger: "2em",
        largest: "3em",
    },
};

export const SPACING = {
    doublexxlarge: "6em",
    xxxlarge: "4em",
    xxlarge: "3em",
    xlarge: "2em",
    large: "1.5em",
    medium: "1.25em",
    standard: "1em",
    small: ".75em",
    xsmall: ".5em",
    xxsmall: ".25em",
};

// -- Common

const contentWidth = 1500;
const largeContentWidth = 1800;
const spacing = {
    side: ["20px", "30px", "45px", "45px", "60px"],
    content: ["25px", "30px", "45px", "45px", "60px"],
    narrowContent: ["25px", "30px", "40px", "40px", "50px"],
};

const largestSideSpacing = spacing.side.filter(x => x).pop() as any;
const siteWidth = contentWidth + (parseNumber(largestSideSpacing) ?? 0) * 2;

export const COMMON = {
    breakpoints: [0, 600, 900, 1200, siteWidth],
    width: {
        content: contentWidth,
        largeContent: largeContentWidth,
        site: siteWidth,
    },
    spacing,
    outline: {
        width: "2px",
        style: "solid",
    },
    defaultProductImagePath: `${STATIC_PATH}/product-not-available.svg`,
    defaultCategoryImagePath: `${STATIC_PATH}/category-not-available.svg`,
};
